<div *ngIf="rights=='contributor'" class="rights">
	<div class="div-opacity div-opacity-contributor">
		<i class="fa fas fa-pen-alt contributor-fa"></i>
		<div class="contributor rights-div">Contributor</div>
	</div>

</div>
<div *ngIf="rights=='now'" class="rights">
	<div class="div-opacity div-opacity-now">
		<i class="fa fas fa-eye viewer-now-fa"></i>
		<div class="viewer-now rights-div">Viewer - Now</div>
	</div>

</div>
<div *ngIf="rights=='future'" class="rights">
	<div class="div-opacity div-opacity-future">
		<i class="fa fas fa-eye viewer-future-fa"></i>
		<div class="viewer-future rights-div">Viewer - Future</div>
	</div>

</div>
<div *ngIf="rights=='never'" class="rights">
	<div class="div-opacity div-opacity-no-access">
		<i class="fa fas fa-lock no-access-fa"></i>
		<div class="no-access rights-div">No Access</div>
	</div>

</div>